<!--=======================================
=            ECOMMERCEPRODUCTS            =
========================================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Ecommerce Products</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="3">
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-4.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Hoodie (Blue)</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-5.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Hoodie (Blue)</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-1.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Half sleeve T-shirt</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-4.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Half sleeve T-shirt</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-2.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Light blue T-shirt</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-3.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Light blue T-shirt</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-7.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Headfone</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
        <v-card class="elevation-1 pa-5 mt-5 ma-3">
          <v-row align="center" justify="center">
            <div class="product-img position-relative">
              <img
                src="../../assets/img/product/img-6.png"
                alt
                class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <a href="#" class="text-dark">Light blue T-shirt</a>
              </h5>

              <p class="text-muted">
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star text-warning"></i>
                <i class="fa fa-star"></i>
              </p>
              <h5 class="my-0">
                <span class="text-muted mr-2">
                  <del>$150</del>
                </span>
                <b>$145</b>
              </h5>
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>
<!--====  End of ECOMMERCEPRODUCTS  ====-->